import React from 'react';
import { NavLink } from 'react-router-dom';

import { ReactComponent as Logo } from 'svg/logo.svg';
import Button from 'components/button';
import { useAuth } from 'context/auth';

import routes from '../../../routes-public';

import './style.css';

const HeaderDesktop = () => {
  const { user } = useAuth();
  return (
    <header id="header" className="header-desktop">
      <div className="header-wrapper wrapper-full">
        <NavLink to="/">
          <Logo className="logo" />
        </NavLink>
        <nav className="main-navigation-wrapper">
          <ul className="main-navigation">
            {routes.map(({ path, name, nav }) => {
              if (!nav) return null;
              return (
                <li key={path}>
                  <NavLink
                    className="route"
                    activeClassName="-active"
                    to={path}
                  >
                    {name}
                  </NavLink>
                </li>
              );
            })}
            <li>
              <div className="nav-divider" />
            </li>
            {user != null ? (
              <li>
                <Button
                  hierarchy="tertiary"
                  href="/dashboard"
                  className="route"
                  shadow={false}
                >
                  Dashboard
                </Button>
              </li>
            ) : (
              <>
                <li>
                  <NavLink
                    className="route"
                    activeClassName="-active"
                    to="/login"
                  >
                    Login
                  </NavLink>
                </li>
                <li>
                  <Button
                    hierarchy="tertiary"
                    href="/signup"
                    className="route"
                    shadow={false}
                  >
                    Sign Up
                  </Button>
                </li>
              </>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default HeaderDesktop;
